import React from 'react';
export const useContentRect = () => {
    const [node, setNode] = React.useState(null);
    const [clientRect, setClientRect] = React.useState();
    React.useEffect(() => {
        if (!node) {
            return undefined;
        }
        const observer = new ResizeObserver((entries) => setClientRect(entries[0].contentRect));
        observer.observe(node);
        // If the preview is opened in a new tab, the resize observer won't update
        // the entries until the tab gains focus which inflates our time to render
        // succceeded.  Manually getting the bounding rect when the node is set
        // circumvents this issue.
        // Normally, we would wrap this use of `getBoundingClientRect` in `requestAnimationFrame`.
        // We can't do that here because `requestAnimationFrame` doesn't run in background tabs.
        setClientRect(node.getBoundingClientRect());
        return () => observer.disconnect();
    }, [node]);
    return { nodeRef: setNode, contentRect: clientRect, node };
};
//# sourceMappingURL=content_rect.preenvesnextjs.map
